// components/PaginationNav.tsx
import { FC } from "react";
import ReactPaginate from "react-paginate";

interface Props {
  currentPage: number;
  pageCount: number;
  onPageChange: (page: { selected: number }) => void;
}

const PaginationNav: FC<Props> = ({ currentPage, pageCount, onPageChange }) => {
  return (
    <ul className="pagination-nav sticky-bottom bg-white m-0 z-1">
      {currentPage !== 1 ? (
          <li className="nxt-lst page-item">
              <button className="btn" onClick = {() => onPageChange({ selected: 0 })} >
                  <i className="bi bi-chevron-double-left"></i> First
              </button>
          </li>
      ) : null}
      <li>
        <ReactPaginate
          nextLabel={<>Next <i className="bi bi-chevron-right"></i></>}
          onPageChange={onPageChange}
          pageRangeDisplayed={3}
          marginPagesDisplayed={2}
          pageCount={pageCount}
          previousLabel={<><i className="bi bi-chevron-left"></i> Previous</>}
          pageClassName="page-item"
          pageLinkClassName="page-link"
          previousClassName="page-item"
          previousLinkClassName="page-link"
          nextClassName="page-item"
          nextLinkClassName="page-link"
          breakLabel="..."
          breakClassName="page-item"
          breakLinkClassName="page-link"
          containerClassName="pagination"
          activeClassName="active"
          renderOnZeroPageCount={null}
          forcePage={currentPage - 1}
        />
      </li>

      {currentPage !== pageCount && (
          <li className="nxt-lst page-item">
              <button className="btn" onClick={() => onPageChange({ selected: pageCount - 1 })}>
                  Last <i className="bi bi-chevron-double-right"></i>
              </button>
        </li>
      )}
    </ul>
  )
}

export default PaginationNav;
